import { Component, ContentChildren, Input, QueryList } from '@angular/core'
import { OptValueDirective } from './option-value.directive'
import { ControlValueAccessor, NgControl } from '@angular/forms'

@Component({
  selector: 'persistent-dropdown',
  template: `
    <div
      dropdown
      placement="bottom right"
      class="btn-group active">
      <button
        dropdownToggle
        class="mat-flat-button post-tabs-button with-text">
        <ng-container *ngTemplateOutlet="selectedItem.templateRef"></ng-container>
      </button>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
        <li *ngFor="let item of items; let i = index;"><a class="dropdown-item" (click)="selectItem(item)">
          <ng-container *ngTemplateOutlet="item.templateRef"></ng-container>
        </a></li>
      </ul>
    </div>
  `
})
export class PersistentDropdown<T> implements ControlValueAccessor {
  @Input('defaultValue') defaultValue: any
  @Input('name') name: string
  @ContentChildren(OptValueDirective) items: QueryList<OptValueDirective<any>>

  selected: OptValueDirective<any>

  constructor(private storage: Storage, private ngControl: NgControl){
    this.ngControl.valueAccessor = this
  }

  ngAfterContentInit() {
    const storedValue = this.storage.getValue(this.name)
    this.selected = this.getItemByValue(storedValue)
  }

  selectItem(item: OptValueDirective<any>){
    this.selected = item
    this.storage.setValue(this.name, item.value)
    this.onChange(item.value)
  }

  getItemByValue(value: T): OptValueDirective<any> {
    let item = null
    if (this.items) {
      item = (value) ? this.items.find(item => item.value == value)
                     : this.items.find(item => item.value == this.defaultValue) || this.items.first
    }
    return item
  }

  get selectedItem(): OptValueDirective<any> {
    return this.selected
  }

  writeValue(value: T): void {
    this.selected = this.getItemByValue(value)
  }

  onChange = (value: T): void => {}
  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn
  }

  onTouch = (): void => {}
  registerOnTouched(fn: () => void): void {
    this.onTouch = fn
  }
}
